<template>
  <div>
    <span v-if="itemValue === undefined" class="grey--text">
      <i>Empty</i>
    </span>
    <span v-else-if="Array.isArray(itemValue)" class="grey--text">
      <i>{{ itemValue.length ? `${itemValue.length} items` : 'Empty' }}</i>
    </span>
    <span v-else>{{ itemValue }}</span>
  </div>
</template>

<script>
  import { getTableDisplayValue } from '../../libs/mongo-datatable'

  export default {
    props: {
      item: { required: true },
      itemSchema: { required: true }
    },
    computed: {
      itemValue () {
        return this.getValue(this.itemSchema, this.item)
      }
    },
    methods: {
      getValue (schema, value) {
        return getTableDisplayValue(schema.type, value)
      }
    }
  }
</script>
